import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';
import { environment } from 'src/environments/environment';
import { LoginService } from '../services/login-service.service';
import { CookieService } from 'ngx-cookie-service';
import { retry } from 'rxjs/operators';

@Component({
    selector: 'app-logging-out',
    templateUrl: './logging-out.component.html',
    styleUrls: ['./logging-out.component.scss'],
})
export class LoggingOutComponent implements OnInit, OnDestroy {
    error = false;
    private subs = new SubSink();
    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private loginService: LoginService,
        private cookieService: CookieService
    ) {}

    ngOnInit() {
        console.log('All: ', this.cookieService.getAll());
        this.subs.add(
            this.httpClient
                .post(environment.IBMLogoutURL, null, { responseType: 'blob' })
                .pipe(retry(20))
                .subscribe(
                    value => {
                        // console.log('Logged Out');
                        this.loginService.loggedOut();
                        this.cookieService.deleteAll();
                        // console.log('Navigating: Login Component');
                        this.router.navigate(['/Login']);
                    },
                    error => {
                        this.error = true;
                    }
                )
        );
    }
}
